
import { Box } from "@mui/material";
import { useCompany } from "../context/CompanyContext";

const LogoAnimated = ({ isFirstImage, handleLogoClick }: any) => {
  const { company } = useCompany();

  // Si hay compañía, mostramos solo el logo
  if (company) {
    return (
      <Box
        sx={{
          position: "relative",
          height: { xs: "45px", sm: "60px", md: "95px" },
          width: "auto",
          mb:2
        }}
      >
        <Box
          component="img"
          src={company.customSettings.logoUrl ?? ""}
          alt={company.name || "Logo Compañía"}
          sx={{
            position: "absolute",
            top: {xs:2, sm:4},
            left: 10,
            height: "100%",
            width: "auto",
            transition: "opacity 0.5s ease-in-out",
            opacity: 1,
          }}
        />
      </Box>
    );
  }

  // Si no hay compañía, usamos el logo animado normal
  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: "45px", sm: "60px", md: "95px" },
        width: "auto",
      }}
    >
      <Box
        component="img"
        src="/assets/images/logo-alien1-v3.png"
        alt="Logo"
        onClick={handleLogoClick}
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "auto",
          transition: "opacity 0.5s ease-in-out",
          opacity: isFirstImage ? 1 : 0,
          "&:hover": {
            filter: "brightness(1.1) drop-shadow(0px 0px 1px cyan)",
          },
        }}
      />
      <Box
        component="img"
        src="/assets/images/logo-alien2-v3.png"
        alt="Logo Alternativo"
        onClick={handleLogoClick}
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "auto",
          transition: "opacity 0.5s ease-in-out",
          opacity: isFirstImage ? 0 : 1,
          "&:hover": {
            filter: "brightness(1.1) drop-shadow(0px 0px 1px cyan)",
          },
        }}
      />
    </Box>
  );
};

export default LogoAnimated;
